import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { LimitOffsetPagingMeta } from '../models/paged-results/limit-offset-paging.model';
import { PagedResults } from '../models/paged-results/paged-results.model';
import { PharmacyStoreIdentifierMappingImport } from 'app/core/models/pharmacy-store-identifier-mapping-import.model';

export class PagedPharmacyStoreIdentifierMappingImports implements PagedResults {
  pharmacyStoreIdentifierMappingImports: PharmacyStoreIdentifierMappingImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.pharmacyStoreIdentifierMappingImports;
  }
}

@Injectable()
export class PharmacyStoreIdentifierMappingImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<PharmacyStoreIdentifierMappingImport> {
    return this.http.get<PharmacyStoreIdentifierMappingImport>(
      `${environment.captureApi.url}/pharmacy_store_identifier_mapping_imports/${id}`
    );
  }

  getList(
    paging: { page: number; pageSize: number } = null,
  ): Observable<PagedPharmacyStoreIdentifierMappingImports> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedPharmacyStoreIdentifierMappingImports>(
      `${environment.captureApi.url}/pharmacy_store_identifier_mapping_imports?${params.toString()}`
    );
  }

  create(signedId: string): Observable<PharmacyStoreIdentifierMappingImport> {
    return this.http.post<PharmacyStoreIdentifierMappingImport>(
      `${environment.captureApi.url}/pharmacy_store_identifier_mapping_imports`,
      {
        PharmacyStoreIdentifierMappingImport: { signedId },
      }
    );
  }

  cancel(id): Observable<PharmacyStoreIdentifierMappingImport> {
    return this.http.patch<PharmacyStoreIdentifierMappingImport>(
      `${environment.captureApi.url}/pharmacy_store_identifier_mapping_imports/${id}/cancel`,
      {}
    );
  }
}
